export interface ThirdPartySoftwareItem {
    name: string;
    license: string;
}

export const THIRD_PARTY_SOFTWARE_LIST: ThirdPartySoftwareItem[] = [
    { name: 'Autofac', license: 'MIT License' },
    { name: 'Active Reports', license: 'Commercial License' },
    { name: 'Dapper', license: 'Apache 2.0 License' },
    { name: 'EntityFramework 6', license: 'MIT License' },
    { name: 'jQuery', license: 'MIT License' },
    { name: 'Newtonsoft JSON', license: 'MIT License' },
    { name: 'NLog', license: 'BSD-3-Clause License' },
    { name: 'Spryng API', license: 'Commercial License' },
    { name: 'TinyMCE', license: 'GNU Lesser General Public License' },
    { name: 'RSDK', license: 'Commercial License' },
    { name: 'Dragon Medical Speechkit', license: 'Commercial License' },
    { name: 'MsBuild', license: 'MIT License' },
    { name: '.NET Core', license: 'MIT License' },
    { name: '.NET Framework', license: 'Microsoft Software License' },
    { name: 'Fellow Oak', license: 'Microsoft Public License' },
    { name: 'Windows SDK', license: 'Microsoft Software License' },
    { name: 'C++ Redistributables', license: 'Microsoft Software License' },
    { name: 'NuGet Packages', license: 'MIT License' },
    { name: 'NPM Packages', license: 'Artistic License 2.0' },
];
